import { connect } from 'react-redux';
import React from "react";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  CardFooter,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from "reactstrap";

import { PanelHeader, Button } from "components";
import { projectActions, loopbackActions } from 'actions';
import { Link } from 'react-router-dom';
import BoundsOnChangeMap from './BoundsOnChangeMap';
import { utils } from '../../helpers';
import User from '../../entities/User'
import LocationSearchInput from './react-places-autocomplete/LocationSearchInput';
import { googleConstants, roleConstants } from '../../constants';
import $ from 'jquery';
import ReactJson from 'react-json-view';
import Select from "react-select";
import { history  } from '../../helpers';
import { fireProjectsChanged } from '../../components/Header/Header';
import { projectService } from '../../services';
import ErrorModal from "../Components/ErrorModal"
import { withTranslation } from 'react-i18next';

window.$ = $;

function getMapCoordinatesObj(map) {
  const bounds = map.getBounds();
  let coordinatesObj = bounds.toJSON();
  let coordinates = JSON.parse(JSON.stringify(coordinatesObj));
  coordinates.center = map.getCenter().toJSON();
  coordinates.zoom = map.getZoom();
  return coordinates;
}

class ProjectEdit extends React.Component {

  constructor(props) {
    super(props);

    this.loggedinUser = User.current();

    this.state = {
      item: {
        id: '',
        name: '',
        description: '',
        databaseName: '',
        geometry: {
          lat: null,
          lng: null
        },
        zoom: 11
      },
      members: [],
      submitted: false,
      map: null,
      loading: false,
      nameState: '',
      databaseNameState: '',
      membersState: '',
      emptyCoordinatesError: false,
      error: null
    };

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleMapMounted = this.handleMapMounted.bind(this)
    this.handleMapBoundsChanged = this.handleMapBoundsChanged.bind(this)
    this.onLocationSearchInputLatLng = this.onLocationSearchInputLatLng.bind(this);
    this.onChangeMembers = this.onChangeMembers.bind(this);

  }


  componentWillMount() {
    const projectId = this.props.match.params.id
    this.setState({
      addMode: projectId == 0,
    })
  }

  componentDidMount() {
    let projectId = this.props.match.params.id;
    if (projectId > 0) {
      this.props.dispatch(projectActions.getById(projectId));
    }
      // carico gli users
      this.props.dispatch(loopbackActions.list('admin','users'));

  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({ error: nextProps.error, modalNotice: true });
    }
    else if (nextProps.project_just_saved){
      fireProjectsChanged();
      history.push('/projects');
    }
    else if (nextProps.users && nextProps.project) {
      let project = nextProps.project;
      let members = ( project.users ? project.users.map((user)=>{ return user.id;}) : []);
      if (project.users) { 
        delete project.users;
      }
      const nextState = {
        item: project,
        members: members,
        precMembers: utils.cloneDeeply(members)
      };
      this.setState(nextState);
    }
  }

  handleChange(e) {
    const { name, value } = e.target
    let item = this.state.item
    item[name] = value
    this.setState({ item })
  }

  handleMapMounted(mountedMap) {
    this.setState({
      map: mountedMap,
    })
  }

  handleMapBoundsChanged() {
    const user = User.current()
    if (User.isWithinGroup(user, roleConstants.CAT)) {
      return;
    }
    const { map } = this.state;
    const coordinates = getMapCoordinatesObj(map);
    let item = this.state.item;
    item.zoom = coordinates.zoom;
    item.geometry = coordinates.center;
    this.setState({
      item,
      emptyCoordinatesError: false
    });
  }

  handleSubmit(e) {

    e.preventDefault();

    let { item, members, precMembers } = this.state
    this.setState({ submitted: true })

    const { dispatch } = this.props

    let hasErrors = false;

    if (item.name == '') {
      this.setState({ nameState: 'has-danger' });
      hasErrors = true;
    }

    if (item.databaseName == '') {
      var uuid = require("uuid");
      var id = uuid.v4();
      item.databaseName = id;
      // this.setState({ databaseNameState: 'has-danger' });
      // hasErrors = true;
    }

    if (!item.geometry.lat) {
      this.setState({ emptyCoordinatesError: true });
      hasErrors = true;
    }

    if (members.length==0) {
      this.setState({ membersState: 'has-danger' });
      hasErrors = true;
    }

    if (hasErrors) {
      return;
    }

    // members
    let toKeepMembers = ( precMembers ? members.filter(function(n) {
      return precMembers.indexOf(n) > -1;
    }) : []);
    let toRemoveMembers = ( precMembers ? precMembers.filter(x => !toKeepMembers.includes(x)) : []);
    let toAddMembers = members.filter(x => !toKeepMembers.includes(x));

    if (item.id == 0) {
      // in add mode elimino l'id
      delete item.id;
      //toAddMembers = [this.loggedinUser.id];
    }

    dispatch(projectActions.edit(item,toRemoveMembers,toAddMembers));

  }

  onLocationSearchInputLatLng(latLng, results) {
    const bounds = results[0].geometry.viewport
    const $mapDiv = $('#projectCoordinatesMap')
    const mapDim = { height: $mapDiv.height(), width: $mapDiv.width() }
    const zoom = utils.googleMapBestZoomLevelFromBounds(bounds, mapDim)
    // const newCoords = {
    //   ...this.state.item.coordinates,
    //   center: {
    //     lat: latLng.lat,
    //     lng: latLng.lng
    //   },
    //   zoom: zoomLevel
    // };

    this.setState({
      item: {
        ...this.state.item,
        geometry: {
          lat: latLng.lat,
          lng: latLng.lng
        },
        zoom
        //coordinates: newCoords
      }
    }, () => {
      const coordinates = getMapCoordinatesObj(this.state.map);
      this.setState({
        item: {
          ...this.state.item,
          geometry: coordinates.center,
          zoom: coordinates.zoom
          //coordinates: coordinates,
        },
        emptyCoordinatesError: false
      })
    })
  }

  onChangeMembers( options ){
    let newMembers = options.map(option=>{ return option.value });
    this.setState({ members: newMembers });
  }


  render() {

    const { addMode, loading, item, map, nameState, databaseNameState, emptyCoordinatesError, membersState, 
      members, error } = this.state

    const { id, name, description, geometry, zoom, databaseName } = item

    const { t, users } = this.props;

    let title = (addMode ? t("Aggiungi progetto") : t("Modifica progetto") + " "+name);

    const usersOptions = (users ? users.map((user)=>{
      return { value: user.id, label: user.name+' '+user.surname}
    }):[]);
    
    return (
      <div>
        {this.state.alert}
        <PanelHeader size="sm" />
        {error && <ErrorModal error={error} onClickHandler={() => { this.setState({ error: null }) }} />}

        <div className="content">
          <Row>
            <Col md={12} xs={12}>
              <Card>
                <CardHeader>
                  <CardTitle>
                    {title}
                    {loading && <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />}
                  </CardTitle>
                </CardHeader>
                {
                  (
                    <Form className="form-horizontal" onSubmit={this.handleSubmit}>
                      <CardBody>
                        <Row>


                          <Col md={12} xs={12}>
                            {/* PROGETTO */}
                            {!addMode &&
                              <Row>
                                <Label sm={2}>{"ID"}</Label>
                                <Col xs={12} sm={10}>
                                  <FormGroup>
                                    <Input type="text" disabled placeholder="" value={id} onChange={()=>{}} />
                                  </FormGroup>
                                </Col>
                              </Row>
                            }
                            <Row>
                              <Label sm={2}>{t("Nome")}</Label>
                              <Col xs={12} sm={10}>
                                <FormGroup className={nameState}>
                                  <Input type="text" value={name} name='name' onChange={this.handleChange} />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Label sm={2}>{t("Descrizione")}</Label>
                              <Col xs={12} sm={10}>
                                <FormGroup>
                                  <Input type="text" value={description} name='description' onChange={this.handleChange} />
                                </FormGroup>
                              </Col>
                            </Row>
                            {!addMode && <Row>
                              <Label sm={2}>{t("Database")}</Label>
                              <Col xs={12} sm={10}>
                                <FormGroup className={databaseNameState}>
                                  <Input type="text" readOnly value={databaseName} name='databaseName' onChange={this.handleChange} />
                                </FormGroup>
                              </Col>
                            </Row>}
                            <Row>
                              <Label sm={2}>{t("Utenti")}</Label>
                              <Col xs={12} sm={10}>
                                <FormGroup className={membersState}>
                                  <Select
                                    className="warning"
                                    multi={true}
                                    closeOnSelect={false}
                                    placeholder=""
                                    name="members"
                                    value={ members }
                                    options={usersOptions}
                                    onChange={ this.onChangeMembers }
                                  />

                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Label sm={2}>{t("Area geografica")}</Label>
                              <Col xs={12} sm={10}>
                                {
                                  map !== null
                                  &&
                                  <LocationSearchInput placeholder={ t("Cerca sulla mappa...") }
                                    onLatLng={this.onLocationSearchInputLatLng}
                                    customErrorMessagForStatus={(errorStatus) => {
                                      if (errorStatus == "ZERO_RESULTS") {
                                        return t("Nessun risultato")
                                      }
                                      else if (errorStatus == "OVER_QUERY_LIMIT") {
                                        return t("Limite di richieste giornaliere superato")
                                      }
                                      else {
                                        return t("Impossibile trovare il luogo cercato")
                                      }
                                    }}
                                  />
                                }
                                {
                                  emptyCoordinatesError && <Label>{t("Selezionare un'area grografica")}</Label>
                                }
                                <div id="projectCoordinatesMap">
                                  <BoundsOnChangeMap
                                    id="projectCoordinatesMap"
                                    googleMapURL={"https://maps.googleapis.com/maps/api/js?key=" + googleConstants.API_KEY + "&libraries=places&language=it&region=IT"}
                                    loadingElement={<div style={{ height: `100%` }} />}
                                    containerElement={<div style={{ height: `450px` }} />}
                                    mapElement={<div style={{ height: `100%` }} />}
                                    handleMapMounted={this.handleMapMounted}
                                    defaultCenter={geometry}
                                    center={geometry}
                                    defaultZoom={zoom}
                                    zoom={zoom}
                                    onDragEnd={this.handleMapBoundsChanged}
                                    onZoomChanged={this.handleMapBoundsChanged}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </CardBody>
                      <CardFooter className="text-right">
                        <Button color="success">{t("Salva")}</Button>
                        &nbsp;&nbsp;
                        <Link to={"/projects"}>
                          <Button color="default">
                            {t("Annulla")}
                          </Button>
                        </Link>
                      </CardFooter>
                    </Form>
                  )
                }
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { projects, loopback } = state;
  let { project, error, project_just_saved } = projects;
  const { users } = loopback;
  return {
    project,
    users: users && users.instances,
    error,
    project_just_saved
  };
}

const connectedProjectEdit = withTranslation()(connect(mapStateToProps)(ProjectEdit));
export { connectedProjectEdit as ProjectEdit };


// WEBPACK FOOTER //
// ./src/views/Projects/ProjectEdit.jsx